import {
  arrayBuilderItemSubsequentPageTitleUI,
  currentOrPastDateSchema,
  currentOrPastDateUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validateDateRange } from 'platform/shared/health-apps';
import { textSchema, textUI } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['health-insurance--provider-title'];
const PROVIDER_LABEL = content['health-insurance--provider-label'];

const INPUT_LABELS = {
  effectiveDate: content['health-insurance--effective-date-label'],
  expirationDate: content['health-insurance--termination-date-label'],
};
const HINT_TEXT = {
  effectiveDate: content['health-insurance--effective-date-hint'],
  expirationDate: content['health-insurance--termination-date-hint'],
};

const VALIDATIONS = [
  validateDateRange({
    startDateKey: 'effectiveDate',
    endDateKey: 'expirationDate',
    rangeErrorMessage: content['validation--date-range'],
  }),
];

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(TITLE_TEXT),
    provider: textUI(PROVIDER_LABEL),
    effectiveDate: currentOrPastDateUI({
      title: INPUT_LABELS.effectiveDate,
      hint: HINT_TEXT.effectiveDate,
    }),
    expirationDate: currentOrPastDateUI({
      title: INPUT_LABELS.expirationDate,
      hint: HINT_TEXT.expirationDate,
    }),
    'ui:validations': VALIDATIONS,
  },
  schema: {
    type: 'object',
    required: ['provider', 'effectiveDate'],
    properties: {
      provider: textSchema,
      effectiveDate: currentOrPastDateSchema,
      expirationDate: currentOrPastDateSchema,
    },
  },
};
